import { render, staticRenderFns } from "./FilePreviewPopup.vue?vue&type=template&id=f0c7506a&"
import script from "./FilePreviewPopup.vue?vue&type=script&lang=js&"
export * from "./FilePreviewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports